<template>
	<div>
		<Drawer :value="visible" title="AI生成" :mask-closable="false" placement="right" :width="drawerWidth"
			:closable="true" @on-visible-change="onVisibleChange">
			<div class="ai-drawer-content">
				<div class="ai-left-panel">
					<Card dis-hover>
                        <div style="text-align:left;">
                            <Form label-position="top">
								<FormItem label="参考图（可选）">
									<Button size="small" type="primary" style="margin-bottom: 5px;" @click="optSameDialogVisible = true">同类型广告</Button>
                                    <upload-images ref="refUploadImages" @edit="handleEdit"/>
                                </FormItem>
                                <FormItem>
                                    <template slot="label">
                                        <span>提示词（必填）</span>
                                    </template>
									<Button size="small" type="primary" @click="optDialogVisible = true">AI帮写</Button>
									<Button size="small" type="primary" @click="handleRefinePrompt" :loading="refining">一键优化</Button>
                                    <Button size="small" type="primary" @click="handleOpenGetRefPrompt" :disabled="getRefPrompting">获取参考图提示词</Button>
                                    <div></div>
									<span style="font-size:14px;color:#999;">如果有参考图，提示词中建议加上“参考图说明”</span>
                                    <Input class="prompt-input" v-model="jimengform.prompt" type="textarea" :rows="6" placeholder="请描述下广告主题、文案、画面元素、参考图说明等，也可以点击“AI帮写”生成" />
                                </FormItem>
                                <!-- 风格选择 -->
                                <FormItem label="风格（可选）">
                                    <Select v-model="jimengform.selected_style" style="width:200px" filterable clearable allow-create @on-create="handleCreateStyle" placeholder="可输入或选择">
                                        <Option v-for="opt in styleOptions" :key="opt" :value="opt">{{ opt }}</Option>
                                    </Select>
                                </FormItem>

								<FormItem label="模型（即梦）">
                                    <RadioGroup v-model="jimengform.model">
                                        <Radio label="doubao-seedream-4-0-250828">4.0</Radio>
                                        <Radio label="doubao-seedream-4-5-251128">4.5</Radio>
                                        <Radio label="doubao-seedream-5-0-260128">5.0</Radio>
                                    </RadioGroup>
                                </FormItem>

                                <FormItem label="尺寸">
                                    <div style="display:flex; align-items:center; flex-wrap:wrap;">
                                        <Select v-model="jimengform.selected_ratio" style="width:100px; margin-right:8px" @on-change="handleRatioOrResolutionChange('i2i')">
											<Option value="AUTO">智能</Option>
											<Option value="CUSTOM">自定义</Option>
                                            <Option value="1:1">1:1</Option>
                                            <Option value="2:3">2:3</Option>
                                            <Option value="3:2">3:2</Option>
                                            <Option value="4:3">4:3</Option>
                                            <Option value="3:4">3:4</Option>
                                            <Option value="16:9">16:9</Option>
                                            <Option value="9:16">9:16</Option>
                                            <Option value="21:9">21:9</Option>
                                        </Select>
                                    </div>
                                    <div v-if="jimengform.selected_ratio === 'CUSTOM'" style="display:flex; align-items:center; flex-wrap:wrap; margin-top:8px;">
                                        <Select v-model="jimengform.selected_placement" clearable placeholder="广告版位" style="width:100px; margin-right:8px" @on-change="handlePlacementChange">
                                            <Option v-for="p in placementOptions" :key="p.key" :value="p.key">{{ p.name }}</Option>
                                        </Select>
                                        <span>宽</span>
                                        <InputNumber v-model="jimengform.width" style="width:80px; margin: 0 6px" :min="1" />
                                        <span>高</span>
                                        <InputNumber v-model="jimengform.height" style="width:80px; margin: 0 6px" :min="1" />
                                        <span style="margin-left:10px;">放大倍数</span>
                                        <Slider v-model="jimengform.size_scale" :min="0.5" :max="10" :step="0.1" style="width:150px;margin:0 9px"
                                            :disabled="!jimengform.selected_placement || jimengform.selected_placement === 'no_choice'"
                                            @on-change="handleScaleChange" />
                                        <InputNumber v-model="jimengform.size_scale" :min="0.5" :max="10" :step="0.1" style="width:80px"
                                            :disabled="!jimengform.selected_placement || jimengform.selected_placement === 'no_choice'"
                                            @on-change="handleScaleChange" />
                                    </div>
									<div v-show="jimengform.selected_ratio === 'CUSTOM'">
										<span style="color:#999;">选择版位后将自动填充推荐尺寸，建议按倍数调整；需满足宽高比[0.1,10]，面积[2560x1440,4096×4096]</span>
									</div>
                                </FormItem>
                                
                                <FormItem label="生图个数">
                                    <Select v-model="jimengform.batch_size" style="width:100px">
                                        <Option :value="1">1</Option>
                                        <Option :value="2">2</Option>
                                        <Option :value="3">3</Option>
                                        <Option :value="4">4</Option>
                                    </Select>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="generating" long
                                        @click="handleGenerate">生成图片</Button>
                                </FormItem>
                            </Form>
                        </div>
					</Card>
				</div>
                <div class="ai-right-panel">
                    <div class="demo-split-pane1" style="padding: 0px 15px;">
                        <div class="images-grid">
                            <show-jimeng-image v-for="item in images" :key="item.id" :item="item" @change:d="handleDelete" @addPreview="handleAddPreview" @setAsAdImage="handleSetAsAdImage"></show-jimeng-image>
                        </div>
                        <div v-if="!images.length" style="text-align:center;color:#888;">生成结果将展示在这里</div>
                    </div>
                    <div style="margin: 10px">
                    <Page :modelValue="currentPage" @on-change="changePage" :total="total_count" :page-size="12" simple />
			    </div>
			</div>
			</div>
        </Drawer>
		<Modal v-model="optDialogVisible" title="AI帮写" :mask="false" width="400" draggable scrollable>	
			<Input v-model="query" type="textarea" :rows="4" placeholder="描述你想生成的广告图，比如“双十一会员卡广告”、“帮我生成一个21天减脂训练营的宣传海报”等" />
			<div slot="footer" style="text-align:right;">
				<Button @click="optDialogVisible = false" :disabled="aigenerating">取消</Button>
				<Button type="primary" @click="handleWritePrompt" :loading="aigenerating">确定</Button>
			</div>
		</Modal>
        <Modal v-model="showEditor" title="参考图编辑" :width="750" :footer-hide="true" :mask-closable="false" class-name="smart-editor-modal" draggable sticky scrollable>
			<div style="height: 520px;width: 100%;">
				<smart-reference-editor :src="sampleSrc" @save="handleSave" />
			</div>
		</Modal>
		<!-- 同类型广告弹窗 -->
		<Modal v-model="optSameDialogVisible" title="同类型广告" :width="750" :mask-closable="false" class-name="smart-editor-modal" draggable sticky scrollable>
			<div style="margin-bottom:10px; display:flex; align-items:center;">
				<Select v-model="ad_content_type" clearable placeholder="请选择广告类型" style="width:200px">
					<Option value="1">营收业务</Option>
					<Option value="2">主推活动</Option>
					<Option value="3">常规活动</Option>
					<Option value="4">会员宣导</Option>
					<Option value="5">用户运营</Option>
				</Select>
				<Button style="margin-left:8px" @click="getSameAds(1)">刷新</Button>
			</div>
			<div class="images-grid">
				<div v-for="item in sameAds" :key="item.ad_id" style="width:100%; text-align:center;">
					<el-image :src="item.material_url" alt="Image" style="width: 120px; height: 120px; border:1px solid #e8e8e8; border-radius:4px;" fit="contain" />
					<div style="margin-top:6px;">
						<Button size="small" type="primary" @click="handleUseAsRef(item.material_url)" :disabled="!item.material_url">选为参考图</Button>
					</div>
				</div>
			</div>
			<div style="margin-top:10px; text-align:right;">
				<Page :modelValue="samePage" @on-change="changeSamePage" :total="sameTotal" :page-size="24" simple />
			</div>
			<div slot="footer">
				<Button @click="optSameDialogVisible=false">关闭</Button>
			</div>
		</Modal>
        <Modal v-model="getRefPromptDialogVisible" title="选择参考图" :width="600" :mask-closable="false" draggable scrollable>
            <div class="images-grid">
                <div v-for="(url,idx) in refImages" :key="idx" style="width:100%; text-align:center;">
                    <el-image :src="url" style="width: 120px; height: 120px; border:1px solid #e8e8e8; border-radius:4px;" fit="contain" @click="selectRefImage(url)" />
                    <div style="margin-top:6px;">
                        <RadioGroup v-model="selectedRefImageUrl">
                            <Radio :label="url">选择</Radio>
                        </RadioGroup>
                    </div>
                </div>
            </div>
            <div slot="footer" style="text-align:right;">
                <Button @click="getRefPromptDialogVisible=false" :disabled="getRefPrompting">取消</Button>
                <Button type="primary" @click="handleConfirmGetRefPrompt" :loading="getRefPrompting">确定</Button>
            </div>
        </Modal>
	</div>
</template>

<script>
import { submitJimengTask, getDesignModelPaintings, queryDesignModelTask, deleteTask, drawLogin, refineADPrompt, aiGenerateADPrompt, adList } from '@/request/api'
import ShowJimengImage from '@/components/common/show_jimeng_image.vue'
import UploadImages from '@/components/common/upload_images.vue'
import SmartReferenceEditor from '@/components/common/smart_reference_editor.vue'
import Cookies from "js-cookie";
export default {
    name: 'AiDrawDialog',
    components: {
        'show-jimeng-image': ShowJimengImage,
        'upload-images': UploadImages,
        'smart-reference-editor': SmartReferenceEditor,
    },
	props: {
		value: { type: Boolean, default: false }
	},
	data() {
        return {
            visible: this.value,
			aigenerating: false,
            generating: false,
			refining: false,
            optSameDialogVisible: false,
            currentPage: 1,
            total_count: 0,
            images: [],
            // 同类型广告选择弹窗数据
            sameAds: [],
            sameTotal: 0,
            samePage: 1,
            pollingTimers: {},
            pollTimer: null,
            drawerWidth: Math.round((typeof window !== 'undefined' ? window.innerWidth : 1200) * 0.7),
            optDialogVisible: false,
            optChatUrl: '',
            showEditor: false,
			sampleSrc: '',
			query: '',
			ad_content_type: '',
            getRefPromptDialogVisible: false,
            getRefPrompting: false,
            refImages: [],
            selectedRefImageUrl: '',
            jimengform: {
                prompt: ``,
                width: null,
                height: null,
                size: 4194304,
                force_single: false,
                batch_size: 2,
                model: 'doubao-seedream-4-0-250828',
                selected_ratio: 'AUTO',
                selected_resolution: '2K',
                selected_style: '',
                aspect: '',
                selected_placement: 'no_choice',
                size_scale: 1,
            },
            styleOptions: ['扁平插画风', '简约设计', '专业摄影', '3d卡通', '电商促销风格'],
            placementOptions: [
				{ key: 'no_choice', name: '不选版位', w: null, h: null, dw: 720, dh: 720 },
                { key: 'feed_card', name: '信息流/健康卡片', w: 2345, h: 2345, dw: 335, dh: 335 },
                { key: 'popup', name: '弹窗', w: 1960, h: 2450, dw: 560, dh: 700 },
                { key: 'home_splash', name: '首页开屏', w: 1500, h: 3248, dw: 750, dh: 1624 },
                { key: 'discover_banner', name: '发现页-活动banner', w: 3470, h: 1325, dw: 694, dh: 265 },
                { key: 'mall_banner', name: '商城页banner', w: 4164, h: 936, dw: 1388, dh: 312 },
                { key: 'member_banner', name: '会员中心banner', w: 4164, h: 960, dw: 694, dh: 160 },
                { key: 'product_main', name: '商品主图', w: 2345, h: 2345, dw: 800, dh: 800 },
            ],
        }
    },
	watch: {
		value(n) { this.visible = n },
		visible(n) { this.$emit('input', n) },
		optSameDialogVisible(n) { if (n) this.getSameAds(1) }
	},
    methods: {
        handleCreateStyle(val){ if (val && !this.styleOptions.includes(val)) this.styleOptions.push(val); this.jimengform.selected_style = val },
        handlePlacementChange(val) {
            const rule = (this.placementOptions || []).find(p => p.key === val)
            if (!rule) return
            this.jimengform.size_scale = 1
            if (rule.key === 'popup') {
                this.jimengform.width = rule.w
                const curH = Number(this.jimengform.height || rule.h)
                this.jimengform.height = Math.min(curH, rule.h)
            } else {
                this.jimengform.width = rule.w
                this.jimengform.height = rule.h
            }
            const w = Number(this.jimengform.width)
            const h = Number(this.jimengform.height)
            if (w && h) this.jimengform.size = w * h
        },
        handleScaleChange(val) {
            const s = Number(val || this.jimengform.size_scale) || 1
            this.jimengform.size_scale = s
            const sp = this.jimengform.selected_placement
            if (!sp || sp === 'no_choice') return
            const rule = (this.placementOptions || []).find(p => p.key === sp)
            if (!rule) return
            
			const baseW = Number(rule.w)
			const baseH = Number(rule.h)
			this.jimengform.width = Math.round(baseW * s)
			this.jimengform.height = Math.round(baseH * s)
            
            const w = Number(this.jimengform.width)
            const h = Number(this.jimengform.height)
            if (w && h) this.jimengform.size = w * h
        },
        onVisibleChange(v) { 
            // 同步 Drawer 的可见性到本地状态，并通过 v-model 反向通知父组件
            this.visible = v
            if (!v) this.stopPolling()
        },
        close() { this.visible = false },
        setAsAdImage(url) { this.$emit('set-image', url); this.close() },
		getData() {
			this.getImages()
		},
		getImages(page = 1, size = 12, keyword = '') {
			getDesignModelPaintings({ page, size, keyword }).then(res => {
				if (res.data && res.data.code === 200) {
					const data = res.data.data || {}
					this.images = data.rows || data.images || []
					this.total_count = data.total_count || data.total || 0
					this.checkAndUpdateImageStatus()
				}
			})
		},
		handleSearch() {
			this.getImages(1, 12, this.keyword)
		},
		changePage(page) {
			this.currentPage = page
			this.getImages(page, 12, this.keyword)
		},
		// 获取同类型广告列表（用于选择参考图）
		getSameAds(page = 1, page_size = 20) {
			adList({ page, page_size, ad_content_type: this.ad_content_type || undefined }).then(res => {
				if (res && res.data && res.data.code === 200) {
					const d = res.data.data || {}
					this.sameAds = d.advertisements || []
					this.sameTotal = d.total || 0
					this.samePage = page
				}
			})
		},
		changeSamePage(page) { this.getSameAds(page) },
		handleUseAsRef(url) {
			const refComp = this.$refs.refUploadImages
			if (refComp && Array.isArray(refComp.uploadList)) {
				refComp.uploadList.push(url)
				this.$Message.success('已添加到参考图')
				this.optSameDialogVisible = false
			} else {
				this.$Message.error('参考图组件未就绪')
			}
		},
		resolveWidthHeightFromAspect(aspect, base = 2048) {
			if (!aspect) return { width: null, height: null }
			const m = aspect.match(/^(\d+):(\d+)$/)
			if (!m) return { width: null, height: null }
			const w = parseInt(m[1])
			const h = parseInt(m[2])
			// 保持面积接近 base^2，按比例折算宽高
			const ratio = w / h
			const height = Math.round(Math.sqrt((base * base) / ratio))
			const width = Math.round(height * ratio)
			return { width, height }
		},
		// 根据图二推荐宽高映射表设置宽高/面积
		handleRatioOrResolutionChange(which) {
			const form = which === 'i2i' ? this.jimengform : this.jimengform
			const ratio = form.selected_ratio
			const res = form.selected_resolution
			// 映射表：仅实现图二列出的 2K / 4K 推荐宽高
			const map2K = {
				'1:1': { w: 2048, h: 2048 },
				'4:3': { w: 2304, h: 1728 },
				'3:2': { w: 2496, h: 1664 },
				'16:9': { w: 2560, h: 1440 },
				'21:9': { w: 3024, h: 1296 },
				'3:4': { w: 1728, h: 2304 },
				'2:3': { w: 1664, h: 2496 },
				'9:16': { w: 1440, h: 2560 },
			}
			const map4K = {
				'1:1': { w: 4096, h: 4096 },
				'4:3': { w: 4694, h: 3520 },
				'3:2': { w: 4992, h: 3328 },
				'16:9': { w: 5404, h: 3040 },
				'21:9': { w: 6198, h: 2656 },
				'3:4': { w: 3520, h: 4694 },
				'2:3': { w: 3328, h: 4992 },
				'9:16': { w: 3040, h: 5404 },
			}
			if (ratio === 'AUTO') {
				// 智能：不固定宽高，按面积控制清晰度
				form.width = null
				form.height = null
				form.aspect = ''
				form.size = res === '4K' ? 4096 * 4096 : 2048 * 2048
				return
			}
			if (ratio === 'CUSTOM') {
				form.aspect = ''
				if (form.width && form.height) {
					form.size = Number(form.width) * Number(form.height)
				} else {
					form.size = res === '4K' ? 4096 * 4096 : 2048 * 2048
				}
				return
			}
			const pair = (res === '4K' ? map4K : map2K)[ratio]
			if (pair) {
				form.width = pair.w
				form.height = pair.h
				form.size = res === '4K' ? 4096 * 4096 : 2048 * 2048
			}
		},
		validateCustomSize(block = false) {
			const w = Number(this.jimengform.width)
			const h = Number(this.jimengform.height)
			if (!w || !h) return true
			const ratio = w / h
			const area = w * h
			const minArea = 2560 * 1440
			const maxArea = 4096 * 4096
			const ratioOk = ratio >= 0.1 && ratio <= 10
			const areaOk = area >= minArea && area <= maxArea
			if (ratioOk && areaOk) {
				this.jimengform.size = area
				return true
			}
			if (block) this.$Message.warning('自定义尺寸不合法：宽高比需在[0.1,10]且面积在[2560x1440,4096x4096]')
			return false
		},
		buildPayload(form, image_urls = []) {
			const { width, height } = form.width && form.height ? { width: form.width, height: form.height } : this.resolveWidthHeightFromAspect(form.aspect)
			let prompt = this.jimengform.prompt.trim()
			if (this.jimengform.selected_style) {
				 prompt += '\n风格：' + this.jimengform.selected_style.trim()
			}
			const payload = {
				prompt: prompt,
				image_urls: image_urls,
				size: (form.selected_ratio === 'CUSTOM' && width && height) ? (Number(width) * Number(height)) : form.size,
				width: width || undefined,
				height: height || undefined,
				force_single: form.force_single,
				batch_size: form.force_single ? 1 : Number(form.batch_size || 1),
				selected_ratio: form.selected_ratio,
				selected_resolution: form.selected_resolution,
                model: form.model,
                selected_placement: form.selected_placement || 'no_choice',
			}
			// 清理 undefined 字段，避免后端报错
			Object.keys(payload).forEach(k => payload[k] === undefined && delete payload[k])
			return payload
		},
		async handleGenerate() {
			if (!this.jimengform.prompt.trim()) { this.$Message.warning('请填写提示词'); return }
			if (this.jimengform.selected_ratio === 'CUSTOM') {
				if (!this.validateCustomSize(true)) return
			}
			this.generating = true
			try {
				const refComp = this.$refs.refUploadImages
				const referImages = refComp && Array.isArray(refComp.uploadList) ? refComp.uploadList : []
				this.handleRatioOrResolutionChange('i2i')
				const payload = this.buildPayload(this.jimengform, referImages)

                submitJimengTask(payload).then(res => {
                    if (res && res.data && res.data.code === 200) {
                        const expected_duration = (res && res.data && res.data.data && res.data.data.expected_duration) || 20
                        this.$Message.success(`提交成功, 预计${expected_duration}秒完成`)
                        this.getImages()
                    } else {
                        this.$Message.error(((res && res.data) ? res.data.msg : '') || '提交失败')
                    }
                }).finally(() => {
					this.generating = false
				})
            } catch (e) { this.$Message.error('提交任务失败') } finally { this.generating = false }
        },
		updateImageStatus(image) {
			// 找到images数组中具有相同id的对象
			let index = this.images.findIndex(img => img.id === image.id);

			if (index !== -1) {
				// 更新images数组中的对象
				this.$set(this.images, index, image)
			}
		},
		stopPolling() {
			if (this.pollingTimers && typeof this.pollingTimers === 'object') {
				Object.keys(this.pollingTimers).forEach(id => {
					const t = this.pollingTimers[id]
					if (t) clearInterval(t)
				})
				this.pollingTimers = {}
			}
			if (this.pollTimer) { clearInterval(this.pollTimer); this.pollTimer = null }
		},
		checkAndUpdateImageStatus() {
			// 当前列表中的所有 id
			const currentIds = new Set((this.images || []).map(img => img.id));
			// 清理已经不在列表中的定时器（例如任务被删除或分页切换）
			Object.keys(this.pollingTimers).forEach(id => {
				if (!currentIds.has(id)) {
					clearInterval(this.pollingTimers[id]);
					this.$delete(this.pollingTimers, id);
				}
			});

			(this.images || []).forEach(image => {
				const done = ['SUCCESS', 'FAILURE'].includes(image.status);
				const exists = this.pollingTimers[image.id];

				// 若已完成，清理已有定时器
				if (done) {
					if (exists) {
						clearInterval(exists);
						this.$delete(this.pollingTimers, image.id);
					}
					return;
				}

				// 未完成且没有定时器则创建轮询
				if (!exists) {
					const timerId = setInterval(() => {
						queryDesignModelTask({ id: image.id }).then(res => {
							if (res.data && res.data.code === 200) {
								const updatedImage = res.data.data || {};
								this.updateImageStatus(updatedImage);
								if (['SUCCESS', 'FAILURE'].includes(updatedImage.status)) {
									const t = this.pollingTimers[image.id];
									if (t) clearInterval(t);
									this.$delete(this.pollingTimers, image.id);
								}
							}
						}).catch(() => { /* 静默失败，继续轮询 */ });
					}, 5000);
					this.$set(this.pollingTimers, image.id, timerId);
				}
			});
		},
		handleDelete(id) {
			deleteTask({ id: id }).then(res => {
				if (res.data.code == 200) {
					this.$Message.success('Success!');
					// 删除任务后清理对应轮询定时器
					const t = this.pollingTimers[id];
					if (t) {
						clearInterval(t);
						this.$delete(this.pollingTimers, id);
					}
					this.getImages(this.currentPage, 12)
				} else {
					this.$Message.error(res.data.msg);
				}
			})
		},
        handleAddPreview(imageUrls){
            const refComp = this.$refs.refUploadImages
            const incoming = Array.isArray(imageUrls) ? imageUrls.filter(Boolean) : []
            if (!refComp || !Array.isArray(refComp.uploadList)) {
                this.$Message.error('参考图组件未就绪，稍后再试')
                return
            }
            const MAX = 5
            const list = refComp.uploadList
            const remain = Math.max(0, MAX - list.length)
            if (remain <= 0) {
                this.$Message.warning(`参考图最多 ${MAX} 张`)
                return
            }
            const unique = incoming.filter(u => list.indexOf(u) === -1)
            const toAdd = unique.slice(0, remain)
            if (toAdd.length) {
                list.push(...toAdd)
                const dupCount = incoming.length - unique.length
                const overflow = unique.length - toAdd.length
                let msg = `已加入参考图 ${toAdd.length} 张`
                if (dupCount > 0) msg += `，忽略重复 ${dupCount} 张`
                if (overflow > 0) msg += `，超过上限忽略 ${overflow} 张`
                this.$Message.info(msg)
            } else {
                this.$Message.warning('没有可添加的参考图')
            }
        },
        handleEdit(file, index) {
			console.log('handleEdit', file, index);
			this.showEditor = true
			this.sampleSrc = file
			this.currentEditIndex = index
		},
        handleSave(payload) {
			// 简单展示保存结果，真实落地可按需上传到后端
			let imageUrl = payload.imageUrl || ''
			if (imageUrl) {
				// 使用 splice 保证 Vue 2 的数组响应性更新
				// 替换当前编辑索引的图片 URL
				this.$refs.refUploadImages.uploadList.splice(this.currentEditIndex, 1, imageUrl)
			}
		},
		handleSetAsAdImage(url, meta) {
			let w = 720, h = 720
			const sp = meta && meta.selected_placement
			if (sp && sp !== 'no_choice') {
				const rule = (this.placementOptions || []).find(p => p.key === sp)
				if (rule) {
					w = Number(rule.dw) || w
					h = Number(rule.dh) || h
				}
			}
			let newUrl = url + `?imageMogr2/thumbnail/${w}x${h}/format/jpg/size-limit/100k`
			this.$emit('set-image', newUrl)
		},
		handleWritePrompt(query, ratio, adContentType) {
			this.aigenerating = true
			if (typeof query === 'string') this.query = query
			this.query = (this.query || '').trim()
			if (!this.query) {
				this.$Message.warning('请输入描述')
				this.aigenerating = false
				return
			}
			if (ratio) {
				this.jimengform.selected_ratio = ratio
			}
			if (adContentType) {
				this.ad_content_type = String(adContentType)
			}
			return aiGenerateADPrompt({ query: this.query })
				.then(res => {
					if (res && res.data && res.data.code == 200) {
						this.$Message.success('Success!')
						this.jimengform.prompt = res.data.data.ai_prompt || ''
						const selected_style = res.data.data.selected_style || '扁平插画风'
                        if (selected_style) {
                            if (!this.styleOptions.includes(selected_style)) {
                                this.styleOptions.push(selected_style)
                            }
                            this.jimengform.selected_style = selected_style
                        }
					} else {
						this.$Message.error((res && res.data && res.data.msg) || '生成失败')
					}
				})
				.catch(err => {
					this.$Message.error('服务异常，请稍后重试')
					console.error(err)
				})
				.finally(() => {
					this.aigenerating = false
					this.optDialogVisible = false
				})
		},
        handleOpenGetRefPrompt() {
            const refComp = this.$refs.refUploadImages
            const list = refComp && Array.isArray(refComp.uploadList) ? refComp.uploadList.filter(Boolean) : []
            if (!list.length) {
                this.$Message.warning('请先添加参考图')
                return
            }
            this.refImages = list
            this.selectedRefImageUrl = list[0]
            this.getRefPromptDialogVisible = true
        },
        selectRefImage(url) { this.selectedRefImageUrl = url },
        handleConfirmGetRefPrompt() {
            const url = this.selectedRefImageUrl
            if (!url) { this.$Message.warning('请选择参考图'); return }
            this.getRefPrompting = true
            const query = '根据我提供的参考图，分析图像内容，生成一份详细的广告图提示词，包括关键元素、场景、构图、色彩、画面风格、背景要素，能够指导AI创作类似图片，字数不超过300字，合成为一段话，只输出提示词'
            refineADPrompt({ prompt: query, file_urls: [url] }).then(res => {
                if (res && res.data && res.data.code == 200) {
                    const text = (res.data.data && res.data.data.refined_prompt) || ''
                    if (text) {
                        this.jimengform.prompt = text
                        this.$Message.success('已获取参考图提示词')
                    } else {
                        this.$Message.warning('未获取到有效提示词')
                    }
                } else {
                    this.$Message.error((res && res.data && res.data.msg) || '获取失败')
                }
            }).catch(() => {
                this.$Message.error('服务异常，请稍后重试')
            }).finally(() => {
                this.getRefPrompting = false
                this.getRefPromptDialogVisible = false
            })
        },
		handleRefinePrompt() {
			this.refining = true
			const refComp = this.$refs.refUploadImages
			let referImages = refComp && Array.isArray(refComp.uploadList) ? refComp.uploadList : []
			let currentPrompt = this.jimengform.prompt + '\n风格：' + this.jimengform.selected_style + '\n尺寸：' + this.jimengform.selected_ratio

			this.$Message.info('提示词优化中，预计10秒，请耐心等待');
			refineADPrompt({ prompt: currentPrompt, file_urls: referImages }).then(res => {
				if (res.data.code == 200) {
					this.$Message.success('Success!');
					this.jimengform.prompt = res.data.data.refined_prompt
				} else {
					this.$Message.error(res.data.msg);
				}
				this.refining = false
			})
		},
	},
	created() {
        drawLogin(
            {
                email: 'iads@yolanda.hk',
                password: 'yol123456'
            }
        ).then(res=>{
            if(res.data.code=='200'){
                Cookies.set('draw_token', res.data.data.token, { expires: 7 })
                this.getImages()
            }else{
                this.$Message.error(res.data.msg);
            }
        }) 
	},
	mounted() {
		if (typeof window !== 'undefined') {
			this._onResize = () => { this.drawerWidth = Math.round(window.innerWidth * 0.7) }
			window.addEventListener('resize', this._onResize)
		}
	},
	beforeDestroy() {
		this.stopPolling()
		if (typeof window !== 'undefined' && this._onResize) {
			window.removeEventListener('resize', this._onResize)
		}
	}
}
</script>

<style scoped>
.ai-drawer-content {
    display: flex;
    gap: 12px;
    height: 100%;
    min-height: calc(100vh - 100px);
    /* 100px 约为 Drawer 头部高度 */
}

.ai-left-panel {
    flex: 0 0 380px;
    width: 380px;
    height: 100%;
    overflow: auto;
}

.ai-left-panel .ivu-card {
    width: 100%;
    min-height: 100%;
}

.ai-left-panel .ivu-card-body {
	padding: 12px;
}

.ai-left-panel .ivu-form {
	padding: 0;
}

.ai-left-panel .ivu-form-item {
	margin-bottom: 12px;
}

.ai-right-panel {
	flex: 1;
	height: 100%;
	overflow: auto;
}

.demo-split-pane1 {
    padding: 10px;
    height: 93%;
    overflow: auto;
}

/* 调小提示词输入框字体（仅作用于本组件） */
.prompt-input >>> textarea {
    font-size: 14px;
}

.images-grid {
    display: grid;
    /* 根据可用空间自动适配每行4、5列（卡片宽度约180px） */
    grid-template-columns: repeat(auto-fit, minmax(168px, 1fr));
    gap: 10px;
    justify-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/common/AiDrawDialog.vue